import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=6ee1e7c8&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&id=6ee1e7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee1e7c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ee1e7c8')) {
      api.createRecord('6ee1e7c8', component.options)
    } else {
      api.reload('6ee1e7c8', component.options)
    }
    module.hot.accept("./Category.vue?vue&type=template&id=6ee1e7c8&scoped=true&", function () {
      api.rerender('6ee1e7c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default-amp/pages/Category.vue"
export default component.exports